import { useQuery } from "@tanstack/react-query";
import { apiRequestContractHandler } from "shared/api/apiRequestContractHandler";
import { getSocietyDashboardIdContract } from "shared/api/contracts/society/societyId/dashboards/dashboardId";
import Spinner from "shared/components/common/Spinner";
import { useSocietySession } from "shared/context/SocietySessionContext";

const SimpleModuleType = ({ dashboardId }: { dashboardId: number }) => {
  const { societyId } = useSocietySession();
  const { data, isLoading } = useQuery({
    queryKey: ["dashboardModule", dashboardId],
    queryFn: async () =>
      apiRequestContractHandler(getSocietyDashboardIdContract, {
        params: {
          societyId,
          dashboardId,
        },
      }),
    refetchOnWindowFocus: false,
  });

  if (isLoading) {
    return (
      <div className="col-span-12 w-full">
        <Spinner />
      </div>
    );
  }
  if (!data) {
    return <></>;
  }

  return (
    <div className="text-center">
      <span className="text-base block">{data.dashboardModule.title}</span>
      <span className="text-2xl font-bold">{String(data.data)}</span>
    </div>
  );
};

export default SimpleModuleType;
